import { useToEmbed } from "../../hooks/useToEmbed";
import "./style.css"

function Video({ data, counter, setData }) {
    const toEmbed = useToEmbed();

    const setValue = (e) => {
        if (counter !== -1) {
            setData({
                ...data,
                video: data.video.map((v, idx) => idx === counter ? e.target.value : v)
            })
        }
        else {
            setData({
                ...data,
                video: e.target.value
            })
        }
    }

    const addVideo = () => {
        setData({ ...data, video: [...data.video, ''] })
    }

    const delVideo = () => {
        const newVideo = data.video.filter((v, id) => id !== counter);
        setData({ ...data, video: newVideo });
    }

    return counter !== -1 ? (
        <div className="video">
            <button
                className="btn_video btn_delete"
                onClick={() => delVideo()}
            ><i className="fas fa-remove"></i></button>

            {data.video.length - 1 === counter &&
                <button
                    className="btn_video btn_more"
                    onClick={() => addVideo()}
                ><i className="fas fa-plus"></i></button>
            }

            {data.video[counter] &&
                <iframe
                    title="video"
                    src={toEmbed(data.video[counter])}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    allowFullScreen
                ></iframe>
            }

            {data.video[counter] === '' && <p>aucune video</p>}

            <div className="input_video">
                <input
                    type="text"
                    placeholder="https://www.youtube.com/watch?v=dQw4w9WgXcQ"

                    value={data.video[counter]}
                    onChange={(e) => setValue(e)}
                />
            </div>
        </div>
    ) : (
        <div className="video">
            {data.video &&
                <iframe
                    title="video"
                    src={toEmbed(data.video)}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    allowFullScreen
                ></iframe>
            }

            {data.video === '' && <p>aucune video</p>}

            <div className="input_video">
                <input
                    type="text"
                    placeholder="https://www.youtube.com/watch?v=dQw4w9WgXcQ"

                    value={data.video}
                    onChange={(e) => setValue(e)}
                />
            </div>
        </div>
    )
}

export default Video;